"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IChargebackdocumentFrozen = exports.IChargebackdocumentInactive = exports.IChargebackdocumentStatus = exports.IChargebackdocumentType = void 0;
var IChargebackdocumentType;
(function (IChargebackdocumentType) {
    IChargebackdocumentType["JPG_JPG"] = "jpg";
    IChargebackdocumentType["JPEG_JPEG"] = "jpeg";
    IChargebackdocumentType["GIF_GIF"] = "gif";
    IChargebackdocumentType["PNG_PNG"] = "png";
    IChargebackdocumentType["PDF_PDF"] = "pdf";
    IChargebackdocumentType["TIFF_TIFF"] = "tiff";
    IChargebackdocumentType["TIF_TIF"] = "tif";
})(IChargebackdocumentType = exports.IChargebackdocumentType || (exports.IChargebackdocumentType = {}));
var IChargebackdocumentStatus;
(function (IChargebackdocumentStatus) {
    IChargebackdocumentStatus["CREATED_CREATED"] = "created";
    IChargebackdocumentStatus["PROCESSED_PROCESSED"] = "processed";
    IChargebackdocumentStatus["FAILED_FAILED"] = "failed";
})(IChargebackdocumentStatus = exports.IChargebackdocumentStatus || (exports.IChargebackdocumentStatus = {}));
var IChargebackdocumentInactive;
(function (IChargebackdocumentInactive) {
    IChargebackdocumentInactive[IChargebackdocumentInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IChargebackdocumentInactive[IChargebackdocumentInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IChargebackdocumentInactive = exports.IChargebackdocumentInactive || (exports.IChargebackdocumentInactive = {}));
var IChargebackdocumentFrozen;
(function (IChargebackdocumentFrozen) {
    IChargebackdocumentFrozen[IChargebackdocumentFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IChargebackdocumentFrozen[IChargebackdocumentFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IChargebackdocumentFrozen = exports.IChargebackdocumentFrozen || (exports.IChargebackdocumentFrozen = {}));
